import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { template } from 'utils/TemplateReplacement';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class CreateGroupNoticeMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div className="message-notice">
          {template(message.messageMeta.noticeMessageTemplate, {
            authorUsername: (
              <Link
                key={`changedUserNotice-${message.id}-${message.messageMeta.authorId}`}
                to={`/users/profile/${message.messageMeta.authorId}`}
              >
                {message.messageMeta.authorUsername}
              </Link>
            ),
            groupName: message.messageMeta.groupName
          })}
        </div>
      </div>
    );
  }
}

CreateGroupNoticeMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    messageMeta: PropTypes.shape({
      noticeMessageTemplate: PropTypes.string.isRequired,
      authorUsername: PropTypes.string.isRequired,
      groupName: PropTypes.string.isRequired,
      authorId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default CreateGroupNoticeMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/CreateGroupNoticeMessageItem.js